<app-upload [scJob]="scJob"></app-upload>
